export const CLIENT_LIST_TABLE_COLUMNS = [
    {name: "", mnemonic: "company_logo_url", ui_class: "str", shrink: true},
    {name: "Client", mnemonic: "company_name", ui_class: "str", searchable: true, shrink: true},
    {name: "ArkBridge ID", mnemonic: "arkbridge_customer_id", ui_class: "str", shrink: true},
    {name: "Work Location", mnemonic: "work_location_label", ui_class: "str", shrink: true},
    {name: "Primary Contact", mnemonic: "linked_users", ui_class: "str", shrink: true, content_align: "left"},
    {name: "Contact Address", mnemonic: "contact_address", ui_class: "str", shrink: true, content_align: "left"},
    {name: "Start Date", mnemonic: "created_at", ui_class: "datetime", shrink: true},
    {name: "Actions", mnemonic: "uuid", ui_class: "str", header_align: "right", content_align: "right"},
];
